import React, { useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as BrandAstraDarkLogo } from '../../../assests/images/LandingAssets/BrandAstraDarkLogo.svg';
import { MenuIcon } from '../../../Common/SvgIcon/CommonSvgIcons';
import { useLocation, useNavigate } from 'react-router-dom';
import MobileNavBarMenu from './partials/MobileNavBarMenu';

const sizes = {
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  desktop: '1800px',
};
export const device = {
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};

const HeaderContainer = styled.div`
  height: 102px;
  display: flex;
  padding: 0px 120px;
  justify-content: space-between;
  @media only screen and ${device.tablet} {
    height: 60px;
    width: 345px;
    padding: unset;
    padding-top: 30px;
    align-items: center;
    margin-bottom: 60px;
    justify-content: space-between;
  }
`;

const LogoContainer = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  &:hover {
    cursor: pointer;
  }
`;

const OptionsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 490px;
  align-items: center;
  @media only screen and ${device.tablet} {
    display: none;
  }
`;
const OptionsText = styled.button`
  color: #121212;
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;

  background: none;
  border: none;
  &:hover {
    cursor: pointer;
    color: var(--BrandAstra_Black, #151515);
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }
`;
const ButtonContainer = styled.div`
  display: flex;
  width: 220px;
  align-items: center;
  justify-content: center;
  justify-content: space-between;
  @media only screen and ${device.tablet} {
    width: unset;
    height: 45px;
    align-items: unset;
  }
`;
const SignInButton = styled.button`
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  padding: 10px 12px;
  justify-content: center;
  align-items: center;
  background: unset;
  height: 35px;
  gap: 10px;
  color: #121212;
  border-radius: 5px;
  border: 1px solid #121212;
  &:hover {
    border: 2.5px solid #121212;
    cursor: pointer;
    margin: -1.5px;
  }
  @media only screen and ${device.tablet} {
    display: none;
  }
`;
const BookaDemoButton = styled.button`
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  width: 125px;
  height: 35px;
  border-radius: 5px;
  border: none;
  background: linear-gradient(93.98deg, #0c3f89 0.31%, #4aa373 99.69%);
  color: var(--PrimaryWhite, #faffff);
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;

  text-align: center;
  transition: background 0.3s ease;
  &:hover {
    cursor: pointer;
    background: linear-gradient(93.98deg, #092f6b 0.31%, #3a865e 99.69%);
  }
  @media only screen and ${device.tablet} {
    width: 102px;
    height: 39px;
    gap: 5.07px;
    border-radius: 5.07px;
    font-family: Inter;
    font-weight: 600;
    font-size: 12.17px;

    text-align: center;
    display: none;
  }
`;
const MobileIconWrapper = styled.button`
  display: none;
  @media only screen and ${device.tablet} {
    display: flex;
    border: none;
    background: none;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
  @media only screen and ${device.tablet} {
    margin-top: unset;
  }
`;
const LandingHeader = (props) => {
  const location = useLocation();
  let navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    props?.setMenuOpen(!menuOpen);
  };

  const scrollToSection = (section) => {
    let anchor = '';
    if (
      location.pathname?.includes('book-a-demo') ||
      location.pathname?.includes('resources') ||
      location.pathname?.includes('blog') ||
      location.pathname?.includes('pricing')
    ) {
      navigate('/', { state: { section } });
      setTimeout(() => {
        anchor = document.querySelector(`#${section}`);
        if (anchor) {
          anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 300); // A
    } else {
      if (section === 'what-do-we-do') {
        anchor = document.querySelector('#what-do-we-do');
      } else if (section === 'solutions') {
        anchor = document.querySelector('#solutions');
      } else if (section === 'pricing') {
        anchor = document.querySelector('#pricing');
      } else if (section === 'impact') {
        anchor = document.querySelector('#impact');
      } else {
        anchor = document.querySelector('#what-do-we-do');
      }
      setTimeout(() => {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    }
  };
  return (
    <>
      <HeaderContainer data-testid='landing-header'>
        <div style={{ display: 'flex', gap: '10px' }}>
          <LogoContainer
            onClick={() => {
              if (
                location.pathname?.includes('book-a-demo') ||
                location.pathname?.includes('blog') ||
                location.pathname?.includes('resources') ||
                location.pathname?.includes('pricing')
              ) {
                navigate('/');
              }
            }}
          >
            <LogoWrapper>
              <BrandAstraDarkLogo height={'45px'} width={'200px'} />
            </LogoWrapper>
          </LogoContainer>
          <OptionsContainer>
            <OptionsText
              onClick={() => {
                scrollToSection('what-do-we-do');
              }}
            >
              Solution
            </OptionsText>

            <OptionsText
              onClick={() => {
                scrollToSection('impact');
              }}
            >
              Impact
            </OptionsText>
            <OptionsText onClick={() => navigate('/pricing')}>
              Plans
            </OptionsText>
            <OptionsText
              onClick={() => {
                navigate('/resources');
              }}
            >
              Resources
            </OptionsText>
          </OptionsContainer>
        </div>
        <ButtonContainer>
          <SignInButton
            newTheme={props?.newTheme}
            onClick={() => {
              navigate('/login');
            }}
          >
            Log In
          </SignInButton>
          <BookaDemoButton
            onClick={() => {
              props?.setPopupOpen(true);
            }}
            style={{ background: props?.bgColor ? props?.bgColor : undefined }}
          >
            Book a Demo
          </BookaDemoButton>
          <MobileIconWrapper onClick={toggleMenu}>{MenuIcon}</MobileIconWrapper>
        </ButtonContainer>
      </HeaderContainer>
      {menuOpen && (
        <MobileNavBarMenu
          openPopup={(data) => {
            props?.setPopupOpen(data);
          }}
          closePoppup={() => {
            toggleMenu();
          }}
          toggleMenu={(sectionName) => {
            scrollToSection(sectionName);
            toggleMenu();
          }}
        />
      )}
    </>
  );
};

export default LandingHeader;
